module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my"
  }, [_c('div', {
    staticClass: "headPart"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.portraitYrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "headright"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userInfoDataAccount.name && _vm.userInfoDataAccount.name.length > 15 ? _vm.userInfoDataAccount.name.substr(0, 15) + '...' : _vm.userInfoDataAccount.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realname === 1),
      expression: "realname===1"
    }],
    staticClass: "realname"
  }, [_vm._v("√实名")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfoDataAccount.status === 4),
      expression: "userInfoDataAccount.status===4"
    }],
    staticClass: "check"
  }, [_vm._v("√审核")])]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('router-link', {
    attrs: {
      "id": "myDetail",
      "to": {
        path: '/myDetail',
        query: {
          id: this.accountId
        }
      }
    }
  }, [_c('span', [_vm._v("预览主页")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "setUp"
  }, [_c('div', {
    staticClass: "setGroup"
  }, [_c('span', [_vm._v("接单设置")]), _vm._v(" "), _c('mt-switch', {
    on: {
      "change": _vm.ordeset
    },
    model: {
      value: (_vm.swit),
      callback: function($$v) {
        _vm.swit = $$v
      },
      expression: "swit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setGroup",
    on: {
      "click": function($event) {
        return _vm.$router.push('/myJobs')
      }
    }
  }, [_c('span', [_vm._v("我的工作")]), _vm._v(" "), _c('icon', {
    staticClass: "next money",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setGroup",
    on: {
      "click": function($event) {
        return _vm.$router.push('/certification')
      }
    }
  }, [_c('span', [_vm._v("资质认证")]), _vm._v(" "), _c('icon', {
    staticClass: "next money",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setGroup",
    on: {
      "click": function($event) {
        return _vm.$router.push('/message')
      }
    }
  }, [_c('span', [_vm._v("我的钱包")]), _vm._v(" "), _c('icon', {
    staticClass: "next money",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setGroup",
    on: {
      "click": function($event) {
        return _vm.$router.push('/passport/resetPwd')
      }
    }
  }, [_c('span', [_vm._v("修改密码")]), _vm._v(" "), _c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setGroup",
    on: {
      "click": function($event) {
        return _vm.$router.push('/passport/resetNickname')
      }
    }
  }, [_c('span', [_vm._v("修改昵称")]), _vm._v(" "), _c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "setGroup"
  }, [_c('icon', {
    staticClass: "setIcon",
    attrs: {
      "name": "address-card-o"
    }
  }), _vm._v(" "), _c('span', [_vm._v("账号绑定")]), _vm._v(" "), _c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "setGroup"
  }, [_c('icon', {
    staticClass: "setIcon",
    attrs: {
      "name": "cog"
    }
  }), _vm._v(" "), _c('span', [_vm._v("通用设置")]), _vm._v(" "), _c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "quite",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1d56d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/index.vue
// module id = 1265
// module chunks = 1